function countdown(id, value, envalue = "") {
  let start = $("#countdown-" + id).data("start");
  let stop = $("#countdown-" + id).data("stop");
  let duration = $("#countdown-" + id).data("duration");
  let interval = 50;
  let step = (stop - start) / (duration / interval);
  let i = parseInt(start);

  let counInterval = setInterval(function () {
    if (i < stop) {
      i += Math.ceil(step);
    } else {
      i = stop;
      clearInterval(counInterval);
    }
    $("#countdown-" + id).html(envalue + i + value);
  }, interval);
}

export default countdown;
